export const getFileStateLabel = (progress: number, error?: boolean) => {
  if (error) return "Failed";
  if (progress === 100) return "Uploaded";
  if (progress === 0) return "Ready to upload";
  return "Uploading";
};

export const getFileStateColor = (progress: number, error?: boolean) => {
  if (error) return "error.main";
  if (progress === 100) return "success.main";
  if (progress === 0) return "info.main";
  return "text.primary";
};
export const getIconStateColor = (progress: number, error?: boolean) => {
  if (error) return "error";
  if (progress === 100) return "success";
  if (progress === 0) return "info";
  return "action";
};
